import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showCategoryActionSheet } from '../../actions/one-app';
import { getHeaderLinks, getActiveHeaderLink } from '../../selectors/header-links-selectors';
import ChangeCategoryTrigger from './change-category-trigger';

const ChangeCategoryOneApp = ({ showCategoryActionSheet, links, activeLink }) => {
  const actionSheetLinks = links.filter(link => link.path !== activeLink.path);
  return <ChangeCategoryTrigger title={activeLink.text} onClick={() => showCategoryActionSheet(actionSheetLinks)} />;
};

ChangeCategoryOneApp.propTypes = {
  links: PropTypes.array.isRequired,
  activeLink: PropTypes.object.isRequired,
  showCategoryActionSheet: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  links: getHeaderLinks(state),
  activeLink: getActiveHeaderLink(state),
});

const mapDispatchToProps = {
  showCategoryActionSheet,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeCategoryOneApp);
